export default "__VITE_ASSET__2wHnv4v8__"